export const DELIVERABLE_TYPES = ['video', 'cutdown', 'stills', 'document', 'other'] as const;
export type DeliverableType = (typeof DELIVERABLE_TYPES)[number];
export const DELIVERABLE_TYPE_LABELS: Record<DeliverableType, string> = {
  video: 'Video', cutdown: 'Cutdown', stills: 'Stills', document: 'Document', other: 'Other',
};
export const DELIVERABLE_STATUSES = ['planned', 'in_progress', 'in_review', 'approved', 'delivered'] as const;
export type DeliverableStatus = (typeof DELIVERABLE_STATUSES)[number];
export const DELIVERABLE_STATUS_LABELS: Record<DeliverableStatus, string> = {
  planned: 'Planned', in_progress: 'In progress', in_review: 'In review', approved: 'Approved', delivered: 'Delivered',
};
export interface DeliverablesSummary {
  counts: Record<DeliverableStatus, number>;
  next_due_date: string | null;
}
